/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2023, Zumper
 */

import { logger } from '../logger'
import { getEnumType } from './getEnumType'

// EnumValue extends (Enum[keyof Enum] | keyof Enum) & number

export type EnumLabel<
  Enum extends object,
  EnumValue extends (Enum[keyof Enum] | keyof Enum) & number,
> = string &
  {
    [EnumLabel in keyof Enum]: Enum[EnumLabel] extends EnumValue ? EnumLabel : never
  }[keyof Enum]

export function getEnumLabel<
  Enum extends object,
  EnumValue extends (Enum[keyof Enum] | keyof Enum) & number,
>(enoom: Enum, value: EnumValue): EnumLabel<Enum, EnumValue> {
  // @ts-expect-error
  if (enoom[value]) {
    return enoom[value] as EnumLabel<Enum, EnumValue>
  }
  for (const [key, otherValue] of Object.entries(enoom)) {
    if (otherValue === value) {
      Object.defineProperty(enoom, value, { enumerable: false, value: key })
      return key as EnumLabel<Enum, EnumValue>
    }
  }
  logger.error(`${value} isn't a value of the ${getEnumType(enoom) ?? 'provided'} enum`)
  return '' as EnumLabel<Enum, EnumValue>
}
